module.exports = __webpack_public_path__ + "static/img/cbsc.2d61f4f6.png";